import React, { Component } from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import { notify } from "../../components/Notify/Notify";
import Aux from "../../hoc/Aux/Aux";
import CalendarUI from "../../components/Calendar/CalendarUI/CalendarUI.js";
import CalendarHeader from "../../components/Calendar/CalendarHeader/CalendarHeader";
import dateFormat from "dateformat";
import ReactTooltip from "react-tooltip";
import YearlyCalendarUI from "../../components/Calendar/YearlyCalendarUI/YearlyCalendarUI";
import "./Calendar.scss";
import CalendarSidebar from "../../components/Calendar/CalendarSidebar/CalendarSidebar";
import { connect } from "react-redux";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../common/UserDataReducer";
import Spinner from "react-bootstrap/Spinner";

const folderColors = [
  { id: 7, value: "7", label: "Primary", color: "#cbd1fe" },
  { id: 1, value: "1", label: "Red", color: "#ff9ead" },
  { id: 2, value: "2", label: "Orange", color: "#ffa575" },
  { id: 3, value: "3", label: "Yellow", color: "#ffda6b" },
  { id: 4, value: "4", label: "Green", color: "#86e575" },
  { id: 5, value: "5", label: "Teal", color: "#6de4d2" },
  { id: 6, value: "6", label: "Purple", color: "#c09eff" },
];

class calendar extends Component {
  state = {
    calendarEvents: [],
    eventIsLoading: false,
    updatedEvents: [],
    calendarHeaderTitle: "",
    weekNumbers: false,
    calendarView: "month",
    year: new Date().getFullYear(),
    sidebar: {
      showSidebar: false,
      height: 0,
    },
    isFirstTimeScroll: true,
    documentTypes: {},
    dateTitles: [],
    rootFolders: [],
    subs: [],
    newSub: [],
    subFolders: {},
    isLoading: true,
    appliedFilter: null,
  };

  calendarRef = React.createRef();
  calendarBodyRef = React.createRef();
  calendarHolderRef = React.createRef();

  componentDidMount() {
    this.setTitle();
    this.fetchFoldersForUser();
  }

  fetchFoldersForUser = () => {
    apolloClient
      .query({
        query: gql`
          query foldersForUser {
            foldersForUser {
              id
              title
              isArchive
              isRoot
              description
              color {
                id
              }
              parentFolder {
                id
                title
              }
              createdBy {
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
                id
                username
                firstName
                lastName
              }
              sharedFolder {
                id
                user {
                  id
                  email
                  username
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                userRole {
                  id
                  name
                }
              }
              pinnedFolder {
                user {
                  id
                }
                folder {
                  id
                  title
                }
              }
              modifiedTs
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        const roots = result.data.foldersForUser.filter((root) => root.isRoot);
        const subs = result.data.foldersForUser.filter((root) => !root.isRoot);
        this.setState({ rootFolders: [...roots], subs: [...subs] }, () => {
          this.loadSubFolders();
          this.props.updateFolders({ ...this.state });
        });
      })
      .catch((e) => {});
  };

  loadSubFolders = () => {
    this.state.rootFolders.map((folderObj) => {
      const variables = {
        parentFolderId: folderObj.id,
      };

      apolloClient
        .query({
          query: gql`
            query subFolder($parentFolderId: UUID!) {
              subFolders(parentFolderId: $parentFolderId, skip: 0) {
                folderId: id
                id
                title
                description
                color {
                  id
                  name
                }
                createdBy {
                  id
                  username
                  firstName
                  lastName
                  email
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                modifiedTs
                parentFolder {
                  id
                  title
                }
                documentSet {
                  id
                  file
                  title
                  inTrash
                  documentType {
                    id
                    title
                  }
                }
                sharedFolder {
                  id
                  user {
                    id
                    email
                    username
                    firstName
                    lastName
                    profile {
                      image
                      role {
                        id
                        name
                      }
                    }
                  }
                  userRole {
                    id
                    name
                  }
                }
                pinnedFolder {
                  user {
                    id
                  }
                  folder {
                    id
                    title
                  }
                }
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (folderObj.isArchive) {
            if (result.data.subFolders.length > 0) {
              this.setState(
                {
                  subFolders: {
                    ...this.state.subFolders,
                    [folderObj.id]: result.data.subFolders,
                  },
                },
                () => {
                  this.props.updateFolders({ ...this.state });
                }
              );
            } else {
              let count = 0;
              const subfolders = this.state.subs.filter(
                (sub) => sub.parentFolder.id === folderObj.id
              );
              subfolders.map((subFolder) => {
                apolloClient
                  .query({
                    query: gql`
                      query documentsOfFolder($folderId: UUID!) {
                        documentsOfFolder(folderId: $folderId) {
                          id
                          file
                          title
                          folder {
                            folderId: id
                            id
                            title
                            description
                            color {
                              id
                              name
                            }
                            createdBy {
                              firstName
                              lastName
                              email
                              profile {
                                image
                                role {
                                  id
                                  name
                                }
                              }
                            }
                            modifiedTs
                            parentFolder {
                              id
                              title
                            }
                          }
                        }
                      }
                    `,
                    variables: {
                      folderId: subFolder.id,
                    },
                  })
                  .then((result) => {
                    const documentsArr = result.data.documentsOfFolder;
                    if (documentsArr.length > 0) {
                      const newObj = {
                        ...documentsArr[0].folder,
                      };

                      this.setState(
                        {
                          newSub: [newObj],
                          subFolders: {
                            ...this.state.subFolders,
                            [folderObj.id]: [...this.state.newSub, newObj],
                          },
                        },
                        () => {
                          this.props.updateFolders({ ...this.state });
                        }
                      );
                    } else {
                      if (count === subfolders.length - 1) {
                        const rootFolders = this.state.rootFolders.filter(
                          (root) => root.id !== subfolders[0].parentFolder.id
                        );
                        this.setState(
                          {
                            rootFolders: rootFolders,
                          },
                          () => {
                            this.props.updateFolders({ ...this.state });
                          }
                        );
                      }
                      count++;
                    }
                  })
                  .catch((e) => {});
                return true;
              });
            }
          } else {
            this.setState(
              {
                subFolders: {
                  ...this.state.subFolders,
                  [folderObj.id]: result.data.subFolders,
                },
              },
              () => {
                this.props.updateFolders({ ...this.state });
              }
            );
          }
        })
        .catch((e) => {
          this.setState({ isLoading: false });
          const title = "Error";
          const detail = e.message;
          const type = "error";
          notify(title, detail, type);
        });
      return true;
    });
  };

  organizeEvents = (items) => {
    // Change events data according to the year calendar
    let newEvents = [];
    items.forEach((event) => {
      newEvents.push({
        ...event,
        startDate: event.start,
        endDate: event.start,
      });
    });
    return newEvents;
  };

  updateCalenderBackend = (startDate, endDate) => {
    if (this.state.calendarView !== "year") {
      this.setState({ isLoading: true });
    }
    const variables = {
      startDate: startDate,
      endDate: endDate,
    };

    apolloClient
      .query({
        query: gql`
          query allEventsBetweenDates($startDate: String!, $endDate: String!) {
            allEventsBetweenDates(startDate: $startDate, endDate: $endDate) {
              id
              documentId
              documentTitle
              documentDescription
              dateTitle
              dateDescription
              documentDate
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        let allEvents = result.data.allEventsBetweenDates;
        let formated_events = [];
        let dateTitles = [];
        allEvents.map((items) => {
          const random = Math.floor(Math.random() * 7);
          formated_events = [
            ...formated_events,
            {
              eventId: items.id,
              title: items.documentTitle,
              extendedProps: folderColors[random],
              start: new Date(items.documentDate),
              documentId: items.documentId,
              documentDescription: items.documentDescription,
              dateTitle: items.dateTitle,
              dateDescription: items.dateDescription,
            },
          ];
          !dateTitles.includes(items.dateTitle) &&
            dateTitles.push(items.dateTitle);
          return true;
        });
        this.setState(
          {
            calendarEvents: this.organizeEvents(formated_events),
            updatedEvents: this.organizeEvents(formated_events),
            dateTitles: dateTitles,
            eventIsLoading: false,
          },
          () => {
            this.state.appliedFilter &&
              this.filterHandler(this.state.appliedFilter);
            this.setState({ isLoading: false });
          }
        );
      })
      .catch((e) => {
        this.setState({ eventIsLoading: false });
        const title = "Error";
        const detail = "oops! Something went wrong";
        const type = "error";
        notify(title, detail, type);
      });
  };

  setTitle = () => {
    if (this.state.calendarView === "year") {
      this.setState({ calendarHeaderTitle: this.state.year });
      let startDate = this.state.year + "-01-01";
      let endDate = this.state.year + "-12-31";
      this.updateCalenderBackend(startDate, endDate);
    } else {
      let calendarApi = this.calendarRef.current.getApi();
      let date = calendarApi.getDate();
      let startDate = dateFormat(
        new Date(dateFormat(date, "yyyy"), dateFormat(date, "mm") - 1, 1),
        "yyyy-mm-dd"
      );
      let endDate = dateFormat(
        new Date(dateFormat(date, "yyyy"), dateFormat(date, "mm"), 0),
        "yyyy-mm-dd"
      );
      this.updateCalenderBackend(startDate, endDate);
      this.setState({ calendarHeaderTitle: dateFormat(date, "mmm yyyy") });
    }
  };

  goToPrev = () => {
    this.closeSidebar();
    ReactTooltip.hide();
    if (this.state.calendarView === "year") {
      this.setState(
        (prevState) => ({
          year: prevState.year - 1,
          eventIsLoading: true,
        }),
        () => {
          this.setTitle();
        }
      );
    } else {
      let calendarApi = this.calendarRef.current.getApi();
      calendarApi.prev();
      this.setTitle();
    }
    // this.setState({ isFirstTimeScroll: true });
  };

  goToNext = () => {
    this.closeSidebar();
    ReactTooltip.hide();
    if (this.state.calendarView === "year") {
      this.setState(
        (prevState) => ({
          year: prevState.year + 1,
          eventIsLoading: true,
        }),
        () => {
          this.setTitle();
        }
      );
    } else {
      let calendarApi = this.calendarRef.current.getApi();
      calendarApi.next();
      this.setTitle();
    }
  };

  updateCalendarView = (type) => {
    this.closeSidebar();
    const weekNumbers = type === "week" ? true : false;
    this.setState(
      {
        calendarView: type,
        eventIsLoading: true,
        weekNumbers,
        year: new Date().getFullYear(),
        isFirstTimeScroll: true,
      },
      () => {
        this.setTitle();
        ReactTooltip.hide();
        this.calendarBodyRef.current.scrollTo(0, 0);
      }
    );
  };

  handleEventClick = (event, fromYearCalendar = false) => {
    // eventObj will be fetched from API
    let eventObj = {};
    if (fromYearCalendar) {
      eventObj = { ...event, description: event.documentDescription };
    } else {
      eventObj.title = event.event.title;
      eventObj.eventId = event.event.extendedProps.eventId;
      eventObj.extendedProps = event.event.extendedProps;
      eventObj.startDate = event.event.extendedProps.startDate;
      eventObj.endDate = event.event.extendedProps.endDate;
      eventObj.documentId = event.event.extendedProps.documentId;
      eventObj.description = event.event.extendedProps.documentDescription;
      eventObj.dateTitle = event.event.extendedProps.dateTitle;
      eventObj.documentDescription =
        event.event.extendedProps.documentDescription;
      eventObj.dateDescription = event.event.extendedProps.dateDescription;
    }

    eventObj.documentFields = [
      { key: "Date Title", value: eventObj.dateTitle },
      { key: "Date", value: dateFormat(eventObj.startDate, "mmm dd, yyyy") },
      {
        key: "Date Description",
        value: eventObj.dateDescription,
      },
    ];
    this.setState({
      isFirstTimeScroll: true,
      sidebar: {
        showSidebar: true,
        ...eventObj,
        height: this.calendarHolderRef.current.clientHeight,
      },
    });
    this.calendarBodyRef.current.scrollTo(0, 0);
  };

  closeSidebar = () => {
    this.setState({ sidebar: { showSidebar: false, height: 0 } });
  };

  setDocumentTypes = (docsObj) => {
    this.setState({ documentTypes: docsObj });
  };

  filterHandler = (appliedFilterConfiguration) => {
    if (Object.keys(appliedFilterConfiguration).length === 0) {
      this.setState({
        calendarEvents: this.state.updatedEvents,
        appliedFilter: appliedFilterConfiguration,
      });
      return;
    }

    let updatedCalendarEvents = [];
    let getDocumentsIds = [];
    // Document Type filter
    const documentFilter = appliedFilterConfiguration["Document Type"];
    if (documentFilter) {
      const docTypes = documentFilter;
      docTypes.map((docType) => {
        let newCalendarEvents = [...this.state.updatedEvents];
        const documentTypes = { ...this.state.documentTypes };
        const allDocuments = documentTypes[docType];
        allDocuments.map((allDocument) => {
          newCalendarEvents.map((newEvent) => {
            newEvent.documentId === allDocument.id &&
              updatedCalendarEvents.push({
                ...newEvent,
                documentType: docType,
              });
            return true;
          });
          return true;
        });
        return true;
      });
      this.setState({
        calendarEvents: updatedCalendarEvents,
        appliedFilter: appliedFilterConfiguration,
      });
    }
    // Folders filter
    const folderFilter = appliedFilterConfiguration["Folder"];
    if (folderFilter) {
      if (updatedCalendarEvents.length === 0) {
        this.props.rootFolders.map((rootFolder) => {
          const folderArr = folderFilter[rootFolder.title];
          if (folderArr) {
            const subFolderArr = this.props.subFolders[rootFolder.id];
            subFolderArr.map((sub) => {
              if (folderArr.includes(sub.title)) {
                sub.documentSet.map((document) => {
                  if (!document.inTrash) {
                    let newCalendarEvents = [...this.state.updatedEvents];
                    newCalendarEvents.map((newEvent) => {
                      if (newEvent.documentId === document.id) {
                        updatedCalendarEvents.push(newEvent);
                      }
                      return true;
                    });
                  }
                  return true;
                });
              }
              return true;
            });
          }
          return true;
        });
        this.setState({
          calendarEvents: updatedCalendarEvents,
          appliedFilter: appliedFilterConfiguration,
        });
      } else {
        this.props.rootFolders.map((rootFolder) => {
          const folderArr = folderFilter[rootFolder.title];
          if (folderArr) {
            const subFolderArr = this.props.subFolders[rootFolder.id];
            subFolderArr.map((sub) => {
              if (folderArr.includes(sub.title)) {
                sub.documentSet.map((document) => {
                  if (!document.inTrash) {
                    const title = document.documentType.title;
                    documentFilter.includes(title) &&
                      getDocumentsIds.push(document.id);
                  }
                  return true;
                });
              }
              return true;
            });
          }
          return true;
        });
        if (getDocumentsIds.length === 0) {
          this.setState({ calendarEvents: [] });
        } else {
          const updatedEvents = [...updatedCalendarEvents];
          const filteredEvents = updatedEvents.filter((updatedEvent) =>
            getDocumentsIds.includes(updatedEvent.documentId)
          );
          this.setState({
            calendarEvents: filteredEvents,
            appliedFilter: appliedFilterConfiguration,
          });
        }
      }
    }
    // Dates filter
    const dateFilter = appliedFilterConfiguration["Dates"];
    if (dateFilter) {
      if (updatedCalendarEvents.length === 0) {
        if (folderFilter) {
          this.setState({ calendarEvents: [] });
        } else {
          const newCalendarEvents = [...this.state.updatedEvents];
          const filterEvents = newCalendarEvents.filter((newEvent) =>
            dateFilter.includes(newEvent.dateTitle)
          );
          this.setState({
            calendarEvents: filterEvents,
            appliedFilter: appliedFilterConfiguration,
          });
        }
      } else if (documentFilter) {
        if (getDocumentsIds.length === 0) {
          if (folderFilter) {
            this.setState({ calendarEvents: [] });
          } else {
            const updatedEvents = [...updatedCalendarEvents];
            const filteredEvents = updatedEvents.filter((updatedEvent) =>
              dateFilter.includes(updatedEvent.dateTitle)
            );
            this.setState({
              calendarEvents: filteredEvents,
              appliedFilter: appliedFilterConfiguration,
            });
          }
        } else {
          const updatedEvents = [...updatedCalendarEvents];
          const filteredEvents = updatedEvents.filter((updatedEvent) =>
            getDocumentsIds.includes(updatedEvent.documentId)
          );
          const dateFilterEvents = filteredEvents.filter((newEvent) =>
            dateFilter.includes(newEvent.dateTitle)
          );
          this.setState({
            calendarEvents: dateFilterEvents,
            appliedFilter: appliedFilterConfiguration,
          });
        }
      } else {
        const updatedEvents = [...updatedCalendarEvents];
        const dateFilterEvents = updatedEvents.filter((newEvent) =>
          dateFilter.includes(newEvent.dateTitle)
        );
        this.setState({
          calendarEvents: dateFilterEvents,
          appliedFilter: appliedFilterConfiguration,
        });
      }
    }
  };

  handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      // bottom of the scroll
      this.goToNext();
      this.calendarBodyRef.current.scrollTo(0, 5);
    }
  };

  handleWheel = (e) => {
    if (this.state.isFirstTimeScroll) {
      // avoid month transition when function triggered two time with 0 top position
      this.setState({ isFirstTimeScroll: false });
      return;
    }
    if (this.calendarBodyRef.current.scrollTop === 0) {
      // top of the scroll
      this.goToPrev();
    }
  };

  render() {
    return (
      <Aux>
        {this.state.isLoading ? (
          <div className="loading-wrap">
            <Spinner animation="border" role="status" className="loader" />
            {/* <UseAnimations
              className="loading-icon"
              animation={loadingIcon}
              autoplay={true}
              loop={true}
              strokeColor="Blue"
              size={40}
            /> */}
          </div>
        ) : null}
        <div className="calender-wraper">
          <ReactTooltip />

          <CalendarHeader
            calendarView={this.state.calendarView}
            calendarHeaderTitle={this.state.calendarHeaderTitle}
            goToPrev={this.goToPrev}
            goToNext={this.goToNext}
            filterHandler={this.filterHandler}
            updateCalendarView={this.updateCalendarView}
            // calendarView={true}
            dateTitles={this.state.dateTitles}
            setDocumentTypes={this.setDocumentTypes}
            {...this.props}
          />

          <div className="overflow-auto">
            <div
              className="calendar-body container-fluid"
              // onScroll={this.handleScroll}
              id="style-scroll"
              // onWheel={this.handleWheel}
              ref={this.calendarBodyRef}
            >
              <div className="calendar-holder" ref={this.calendarHolderRef}>
                {this.state.calendarView === "year" ? (
                  !this.state.eventIsLoading ? (
                    <YearlyCalendarUI
                      year={this.state.year}
                      handleEventClick={this.handleEventClick}
                      calendarEvents={this.state.calendarEvents}
                      calendarIsSidebar={this.state.sidebar.showSidebar}
                    />
                  ) : (
                    <div
                      className="progress-icon"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "96vw",
                        height: "84vh",
                      }}
                    >
                      <Spinner animation="border" role="status" />
                    </div>
                  )
                ) : (
                  <CalendarUI
                    calendarEvents={this.state.calendarEvents}
                    calendarRef={this.calendarRef}
                    handleEventClick={this.handleEventClick}
                    weekNumbers={this.state.weekNumbers}
                  />
                )}
              </div>

              {this.state.sidebar.showSidebar ? (
                <div
                  className="col-3 calendar-sidebar-holder"
                  // style={{ height: `${this.state.sidebar.height}px` }}
                >
                  <CalendarSidebar
                    {...this.state.sidebar}
                    closeSidebar={this.closeSidebar}
                    userRoleId={this.props.userRoleId}
                    currentUserInfo={this.props.currentUserInfo}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(calendar);
